import { LoadablePaint } from '@confluence/loadable';

export const LazyNBMPage = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-NBMPage" */ './NBMPage.tsx')).NBMPage,
});
